import { render, staticRenderFns } from "./form-board-update.vue?vue&type=template&id=33d57e31&"
import script from "./form-board-update.vue?vue&type=script&lang=js&"
export * from "./form-board-update.vue?vue&type=script&lang=js&"
import style0 from "./form-board-update.vue?vue&type=style&index=0&id=33d57e31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports